<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  [canEdit]="editAccessRights"
>
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="titleCollapsed ? 'false' : 'true'"
          (click)="titleCollapsed = !titleCollapsed"
          aria-controls="home-page-title"
        >
          <span class="fs-3">{{
            'configurationOptionModule.homePageTitle' | translate
          }}</span>

          <i
            class="fa fa-fw ms-auto"
            [ngClass]="titleCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            aria-hidden="true"
            role="img"
          ></i>
        </button>
      </h2>
    </div>

    <div *ngIf="!titleCollapsed" class="card-body" id="home-page-title">
      <language-inputs
        [formGroup]="form"
        [oneRequired]="true"
      ></language-inputs>
    </div>
  </section>

  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="featuredContentCollapsed ? 'false' : 'true'"
          (click)="featuredContentCollapsed = !featuredContentCollapsed"
          aria-controls="home-page-featured-content"
        >
          <span class="fs-3">{{
            'configurationOptionModule.featuredContent' | translate
          }}</span>

          <i
            class="fa fa-fw ms-auto"
            [ngClass]="
              featuredContentCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'
            "
            aria-hidden="true"
            role="img"
          ></i>
        </button>
      </h2>
    </div>

    <ng-container *ngIf="!featuredContentCollapsed">
      <div
        class="card-body"
        id="home-page-featured-content"
        formArrayName="slides"
        cdkDropList
        [cdkDropListData]="slides.controls"
        (cdkDropListDropped)="dropSlide($event)"
      >
        <ng-container *ngFor="let slide of slides.controls; let i = index">
          <div class="card mb-3 bg-body-tertiary" [formGroupName]="i" cdkDrag>
            <div
              class="card-header d-flex align-items-center justify-content-between"
              [ngClass]="slideCollapsed[i] ? 'border-bottom-0' : ''"
            >
              <button
                type="button"
                class="btn btn-ghost-secondary me-2"
                cdkDragHandle
                [attr.aria-label]="'general.order' | translate"
              >
                <i
                  class="fa fa-grip-vertical"
                  aria-hidden="true"
                  role="img"
                ></i>
              </button>
              <h3 class="accordion-header">
                <button
                  type="button"
                  class="accordion-button"
                  [attr.aria-expanded]="slideCollapsed[i] ? 'false' : 'true'"
                  (click)="slideCollapsed[i] = !slideCollapsed[i]"
                  [attr.aria-controls]="'home-page-slide-' + i"
                >
                  <span
                    class="d-flex flex-column align-items-start flex-grow-1"
                  >
                    <span
                      class="fs-4 text-break"
                      *ngIf="slide.get('url')?.value"
                    >
                      {{ slide.get('url')?.value }}
                    </span>
                    <span class="text-small text-body">
                      {{ 'configurationOptionModule.slide' | translate }}
                      #{{ i + 1 }}
                    </span>
                  </span>
                  <i
                    class="fa fa-fw ms-auto"
                    [ngClass]="
                      slideCollapsed[i] ? 'fa-chevron-down' : 'fa-chevron-up'
                    "
                    aria-hidden="true"
                    role="img"
                  ></i>
                </button>
              </h3>
              <button
                type="button"
                class="btn btn-ghost-secondary ms-2"
                (click)="removeSlide(i)"
                [canSee]="editAccessRights"
                [attr.aria-label]="'general.delete' | translate"
              >
                <i class="fa fa-trash-alt" aria-hidden="true" role="img"></i>
              </button>
            </div>

            <div
              class="card-body bg-body"
              *ngIf="!slideCollapsed[i]"
              [attr.id]="'home-page-slide-' + i"
            >
              <div class="col-12 col-lg-6 mb-3">
                <label
                  class="form-label"
                  [attr.for]="'home-page-slide-url-' + i"
                >
                  {{ 'general.url' | translate }}
                  <i
                    class="ms-2 fa fa-question-circle"
                    role="button"
                    tabindex="0"
                    [tooltip]="
                      'configurationOptionModule.urlCanBeInternalOrExternal'
                        | translate
                    "
                  ></i>
                </label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="url"
                  [attr.id]="'home-page-slide-url-' + i"
                />
              </div>

              <nav
                class="mb-4"
                [attr.aria-label]="'wcag.translationLangMenu' | translate"
              >
                <ul class="nav nav-tabs" role="tablist">
                  <li *ngFor="let language of languageCodes" class="nav-item">
                    <button
                      type="button"
                      class="nav-link position-relative"
                      [ngClass]="
                        getSlideLanguage(i) === language ? 'active' : ''
                      "
                      (click)="setSlideLanguage(i, language)"
                      role="tab"
                      [attr.aria-selected]="
                        getSlideLanguage(i) === language ? 'true' : 'false'
                      "
                    >
                      <span
                        [ngClass]="'flag flag-' + language"
                        role="img"
                        [attr.aria-label]="'wcag.' + language | translate"
                      ></span>
                      <span
                        class="invalid-feedback"
                        role="alert"
                        aria-atomic="true"
                        *ngIf="hasMissingSlideLanguageFields(i, language)"
                      >
                        <i
                          role="img"
                          class="fas fa-exclamation-circle"
                          [attr.aria-label]="
                            'wcag.missingTranslation' | translate
                          "
                        ></i>
                      </span>
                    </button>
                  </li>
                </ul>
              </nav>

              <ng-container *ngFor="let language of languageCodes">
                <ng-container *ngIf="getSlideLanguage(i) === language">
                  <div class="col-12 col-lg-6 mb-4">
                    <label class="form-label">
                      {{
                        'configurationOptionModule.featuredBlockImage'
                          | translate
                      }}
                    </label>
                    <upload-file
                      class="home-page-upload-file"
                      *ngIf="!slide.get(getImageUrlKey(language))?.value"
                      (onSubmitFile)="onSubmitSlideImage($event, i)"
                    ></upload-file>
                    <p
                      class="form-text mb-0"
                      *ngIf="!slide.get(getImageUrlKey(language))?.value"
                    >
                      {{
                        'configurationOptionModule.featuredBlockImageRatioHelp'
                          | translate
                      }}
                    </p>
                    <div
                      class="align-items-center row mt-3"
                      *ngIf="
                        slide.get(getImageUrlKey(language))?.value as imagePath
                      "
                    >
                      <div class="col-12 mb-2">
                        <img
                          class="rounded img-fluid w-100 object-fit-contain home-page-image-preview"
                          [src]="getImageUrl(imagePath)"
                          [alt]="
                            slide.get(getAltTextKey(language))?.value ||
                            ('configurationOptionModule.featuredBlockImage'
                              | translate)
                          "
                        />
                      </div>
                      <div class="col-12">
                        <button
                          type="button"
                          class="btn btn-soft-danger"
                          (click)="onDeleteSlideImage(i)"
                          [canSee]="editAccessRights"
                        >
                          <i
                            class="fa fa-trash"
                            aria-hidden="true"
                            role="img"
                            [attr.aria-label]="'general.delete' | translate"
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6 mb-3">
                    <label
                      class="form-label"
                      [attr.for]="
                        'home-page-slide-alt-text-' + language + '-' + i
                      "
                    >
                      {{
                        'configurationOptionModule.featuredBlockImageAltText'
                          | translate
                      }}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      [formControlName]="getAltTextKey(language)"
                      [attr.id]="
                        'home-page-slide-alt-text-' + language + '-' + i
                      "
                    />
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="card-footer">
        <button
          type="button"
          class="btn btn-soft-primary"
          (click)="addSlide()"
          [disabled]="slides.length >= maxSlides"
          [canSee]="editAccessRights"
        >
          {{ 'general.addSlide' | translate }}
        </button>
      </div>
    </ng-container>
  </section>

  <section class="card mb-3">
    <div class="card-header card-collapse">
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="buttonsCollapsed ? 'false' : 'true'"
          (click)="buttonsCollapsed = !buttonsCollapsed"
          aria-controls="home-page-buttons"
        >
          <span class="fs-3">{{
            'configurationOptionModule.buttons' | translate
          }}</span>

          <i
            class="fa fa-fw ms-auto"
            [ngClass]="buttonsCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            aria-hidden="true"
            role="img"
          ></i>
        </button>
      </h2>
    </div>

    <ng-container *ngIf="!buttonsCollapsed">
      <div
        class="card-body"
        id="home-page-buttons"
        formArrayName="buttons"
        cdkDropList
        [cdkDropListData]="buttons.controls"
        (cdkDropListDropped)="dropButton($event)"
      >
        <ng-container *ngFor="let button of buttons.controls; let i = index">
          <div class="card mb-3 bg-body-tertiary" [formGroupName]="i" cdkDrag>
            <div
              class="card-header d-flex align-items-center justify-content-between"
              [ngClass]="buttonCollapsed[i] ? 'border-bottom-0 ' : ''"
            >
              <button
                type="button"
                class="btn btn-ghost-secondary me-2"
                cdkDragHandle
                [attr.aria-label]="'general.order' | translate"
              >
                <i
                  class="fa fa-grip-vertical"
                  aria-hidden="true"
                  role="img"
                ></i>
              </button>
              <h3 class="accordion-header">
                <button
                  type="button"
                  class="accordion-button"
                  [attr.aria-expanded]="buttonCollapsed[i] ? 'false' : 'true'"
                  (click)="buttonCollapsed[i] = !buttonCollapsed[i]"
                  [attr.aria-controls]="'home-page-button-' + i"
                >
                  <span
                    class="d-flex flex-column align-items-start flex-grow-1"
                  >
                    <span class="fs-4" *ngIf="button.get('title_en')?.value">
                      {{ button.get('title_en')?.value }}
                    </span>
                    <span class="text-small text-body">
                      {{ 'configurationOptionModule.button' | translate }}
                      #{{ i + 1 }}
                    </span>
                  </span>
                  <i
                    class="fa fa-fw ms-auto"
                    [ngClass]="
                      buttonCollapsed[i] ? 'fa-chevron-down' : 'fa-chevron-up'
                    "
                    aria-hidden="true"
                    role="img"
                  ></i>
                </button>
              </h3>
              <button
                type="button"
                class="btn btn-ghost-secondary ms-2"
                (click)="removeButton(i)"
                [canSee]="editAccessRights"
                [attr.aria-label]="'general.delete' | translate"
              >
                <i class="fa fa-trash-alt" aria-hidden="true" role="img"></i>
              </button>
            </div>

            <div
              class="card-body bg-body"
              *ngIf="!buttonCollapsed[i]"
              [attr.id]="'home-page-button-' + i"
            >
              <language-inputs
                [formGroup]="getButtonGroup(i)"
                [oneRequired]="true"
              ></language-inputs>

              <div>
                <div class="col-12 col-lg-6 mb-3">
                  <label
                    class="form-label"
                    [attr.for]="'home-page-button-url-' + i"
                  >
                    {{ 'general.url' | translate }}
                    <i
                      class="ms-2 fa fa-question-circle"
                      role="button"
                      tabindex="0"
                      [tooltip]="
                        'configurationOptionModule.urlCanBeInternalOrExternal'
                          | translate
                      "
                    ></i>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="url"
                    [attr.id]="'home-page-button-url-' + i"
                    [ngClass]="{
                      'is-invalid':
                        button.get('url')?.invalid &&
                        (button.get('url')?.dirty || button.get('url')?.touched)
                    }"
                  />
                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    *ngIf="
                      button.get('url')?.invalid &&
                      (button.get('url')?.dirty || button.get('url')?.touched)
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.required' | translate }}
                  </p>
                </div>

                <div class="col-12 col-lg-3 mb-3">
                  <label
                    class="form-label"
                    [attr.for]="'home-page-button-icon-' + i"
                  >
                    {{ 'configurationOptionModule.icon' | translate }}
                    <span
                      class="ms-2 text-body"
                      tabindex="0"
                      role="button"
                      [tooltip]="
                        'configurationOptionModule.fontAwesomeSearchInfo'
                          | translate
                      "
                    >
                      <i
                        class="fa fa-question-circle"
                        aria-hidden="true"
                        role="img"
                      ></i>
                    </span>
                    <a
                      href="https://fontawesome.com/v7/search?ip=classic&s=solid"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="ms-2 text-primary"
                      [attr.aria-label]="
                        'configurationOptionModule.useExternalLinkIcon'
                          | translate
                      "
                      [tooltip]="
                        'configurationOptionModule.useExternalLinkIcon'
                          | translate
                      "
                    >
                      <i
                        class="fa fa-arrow-up-right-from-square"
                        aria-hidden="true"
                        role="img"
                      ></i>
                    </a>
                  </label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      formControlName="icon"
                      [attr.id]="'home-page-button-icon-' + i"
                      [ngClass]="{
                        'is-invalid':
                          button.get('icon')?.invalid &&
                          (button.get('icon')?.dirty ||
                            button.get('icon')?.touched)
                      }"
                    />
                    <span class="input-group-text">
                      <i
                        class="fa fa-fw"
                        [ngClass]="getIconClass(button.get('icon')?.value)"
                        aria-hidden="true"
                        role="img"
                      ></i>
                    </span>
                  </div>
                  <p
                    class="invalid-feedback"
                    role="alert"
                    aria-atomic="true"
                    *ngIf="
                      button.get('icon')?.invalid &&
                      (button.get('icon')?.dirty || button.get('icon')?.touched)
                    "
                  >
                    <i
                      role="img"
                      class="fas fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                    {{ 'general.required' | translate }}
                  </p>
                </div>

                <div class="col-12 col-lg-3 mb-3">
                  <label
                    class="form-label"
                    [attr.for]="'home-page-button-style-' + i"
                  >
                    {{ 'configurationOptionModule.style' | translate }}
                  </label>
                  <select
                    class="form-select"
                    formControlName="style"
                    [attr.id]="'home-page-button-style-' + i"
                  >
                    <option
                      *ngFor="let option of styleOptions"
                      [ngValue]="option.value"
                    >
                      {{ option.label | translate }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="card-footer">
        <button
          type="button"
          class="btn btn-soft-primary"
          (click)="addButton()"
          [canSee]="editAccessRights"
        >
          {{ 'configurationOptionModule.addButton' | translate }}
        </button>
      </div>
    </ng-container>
  </section>

  <div class="form-footer justify-content-end sticky-bottom">
    <button class="btn btn-primary" type="submit" [canSee]="editAccessRights">
      {{ 'general.save' | translate }}
    </button>
  </div>
</form>
